import { T as TaskType } from './index-96474be4.js';
export { S as SessionIO, T as TaskType } from './index-96474be4.js';
import { _ as __spreadArray, a as __extends, b as __awaiter, c as __generator, d as __assign, L as LogKey } from './constant-89e708bf.js';
export { C as ChannelName, L as LogKey, M as MAX_CONNECT_RETRY_TIMEOUT_MS, N as NCHAT_CHANNEL_TIMEOUT_MS, e as N_CHAT_CHANNEL, S as SOCKET_EVENT, f as SessionIOError, T as TimeoutNatChannelError, U as UnexpectedSessionIOError } from './constant-89e708bf.js';
import '@financial/common-utils';
import 'axios';
import 'nanoid';
import 'socket.io-client';

var FE_UPDATE_ERROR_CODE;
(function (FE_UPDATE_ERROR_CODE) {
    FE_UPDATE_ERROR_CODE["API_REQUEST_FAILURE"] = "FE00001";
    FE_UPDATE_ERROR_CODE["API_RESPONSE_UP_TO_DATE"] = "FE00002";
    FE_UPDATE_ERROR_CODE["API_RESPONSE_COOLING"] = "FE00003";
    FE_UPDATE_ERROR_CODE["API_RESPONSE_OTHER"] = "FE00004";
    FE_UPDATE_ERROR_CODE["TIMEOUT_RESPONSE"] = "FE00005";
    FE_UPDATE_ERROR_CODE["API_RESPONSE_CONCURRENT_TASK"] = "FE00006";
    FE_UPDATE_ERROR_CODE["UNHANDLED_ERROR"] = "FE99999";
})(FE_UPDATE_ERROR_CODE || (FE_UPDATE_ERROR_CODE = {}));
var SUCCESS_CODE_LIST = ['00000'];
var UP_TO_DATE_CODE_LIST = ['00001'];
var CONNECTION_ERROR_CODE_LIST = ['40101', '40104', '40105', '40106'];
var TEMPORARY_ERROR_CODE_LIST = ['50001', '50002', '50003', '50004', '50005', '50006', '50007', '50009'];
var UPDATER_RETRY_CODE_LIST = __spreadArray(__spreadArray([], TEMPORARY_ERROR_CODE_LIST, true), ['40101', '40104', '40105'], false);
var SYSTEM_MAINTENANCE_ERROR_CODE_LIST = ['50008'];
var MyDataUpdateError = /** @class */ (function (_super) {
    __extends(MyDataUpdateError, _super);
    function MyDataUpdateError(msg, code, errorInfo) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.errorInfo = errorInfo;
        _this.name = 'MyDataUpdaterError';
        return _this;
    }
    return MyDataUpdateError;
}(Error));
var ApiRequestFailureError = /** @class */ (function (_super) {
    __extends(ApiRequestFailureError, _super);
    function ApiRequestFailureError(errorInfo) {
        var _this = _super.call(this, 'API 요청 실패', FE_UPDATE_ERROR_CODE.API_REQUEST_FAILURE, errorInfo) || this;
        _this.name = 'ApiRequestFailureError';
        return _this;
    }
    return ApiRequestFailureError;
}(MyDataUpdateError));
var TimeoutResponseError = /** @class */ (function (_super) {
    __extends(TimeoutResponseError, _super);
    function TimeoutResponseError(errorInfo) {
        var _this = _super.call(this, '업데이트 응답 타임아웃', FE_UPDATE_ERROR_CODE.TIMEOUT_RESPONSE, errorInfo) || this;
        _this.name = 'TimeoutResponseError';
        return _this;
    }
    return TimeoutResponseError;
}(MyDataUpdateError));
var UnhandledError = /** @class */ (function (_super) {
    __extends(UnhandledError, _super);
    function UnhandledError(code, errorInfo) {
        var _this = _super.call(this, '처리되지 않은 오류', code, errorInfo) || this;
        _this.name = 'UnhandledError';
        return _this;
    }
    return UnhandledError;
}(MyDataUpdateError));

function isPfmsTaskRequest(taskRequest) {
    return taskRequest.type === TaskType.Pfms || taskRequest.type === TaskType.Pfms2;
}
function isPfmsTaskResponse(taskResponse) {
    return taskResponse.type === TaskType.Pfms || taskResponse.type === TaskType.Pfms2;
}
function isMyUpdaterError(error) {
    return typeof error === 'object' && error !== null && 'code' in error && 'errorInfo' in error;
}
function isTimeoutResponse(response) {
    return response.type === TaskType.TaskTimeout;
}

var MyDataUpdater = /** @class */ (function () {
    function MyDataUpdater(sessionIO, _a) {
        var handleError = _a.handleError, fetch = _a.fetch, logger = _a.logger;
        this.sessionIO = sessionIO;
        this.handleError = handleError;
        this.fetch = fetch;
        this.logger = logger;
    }
    MyDataUpdater.prototype.sessionIoInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sessionIO.init()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.sessionIO.waitUntilInitialized()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MyDataUpdater.prototype.fetchUpdateRequestApi = function (taskList) {
        return __awaiter(this, void 0, void 0, function () {
            var taskResponseList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (taskList.length === 0) {
                            return [2 /*return*/, []];
                        }
                        return [4 /*yield*/, this.fetch.updateRequest(taskList).catch(function () {
                                // API 요청에 실패하면 자체적으로 실패 응답을 만든다.
                                return taskList.map(function (_a) {
                                    var reqId = _a.reqId, type = _a.type;
                                    var failureTaskResponse = {
                                        reqId: reqId,
                                        type: type,
                                        taskId: null,
                                    };
                                    return failureTaskResponse;
                                });
                            })];
                    case 1:
                        taskResponseList = _a.sent();
                        return [2 /*return*/, taskResponseList];
                }
            });
        });
    };
    MyDataUpdater.prototype.waitUntilSessionIoResponse = function (taskId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            var _this = this;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, new Promise(function (resolve) {
                            _this.sessionIO.subscribe(taskId, resolve);
                        })];
                    case 1:
                        response = _c.sent();
                        (_b = (_a = this.logger) === null || _a === void 0 ? void 0 : _a.info) === null || _b === void 0 ? void 0 : _b.call(_a, response);
                        return [2 /*return*/, response];
                }
            });
        });
    };
    MyDataUpdater.prototype.waitUntilAllSessionIoResponse = function (taskResponseList_1, _a, _b, requestPathname_1) {
        return __awaiter(this, arguments, void 0, function (taskResponseList, _c, _d, requestPathname) {
            var successList, failureList, retryList, taskRequestInfo;
            var _this = this;
            var taskRequestList = _c.taskList, onSuccess = _c.onSuccess, onFailure = _c.onFailure;
            var retryLimit = _d.retryLimit, retryCount = _d.retryCount;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        successList = [];
                        failureList = [];
                        retryList = [];
                        taskRequestInfo = taskRequestList.reduce(function (acc, taskRequest) {
                            var _a;
                            return __assign(__assign({}, acc), (_a = {}, _a[taskRequest.reqId] = taskRequest, _a));
                        }, {});
                        return [4 /*yield*/, Promise.all(taskResponseList.map(function (taskResponse) { return __awaiter(_this, void 0, void 0, function () {
                                var taskId, reqId, taskRequest, taskInfo, information, response, _a, msg, code, e_1, updateErrorInfo;
                                var _b, _c, _d, _e, _f;
                                return __generator(this, function (_g) {
                                    switch (_g.label) {
                                        case 0:
                                            taskId = taskResponse.taskId, reqId = taskResponse.reqId;
                                            taskRequest = taskRequestInfo[reqId];
                                            taskInfo = {
                                                taskRequest: taskRequest,
                                                taskResponse: taskResponse,
                                            };
                                            information = {
                                                taskId: taskId,
                                                taskInfo: taskInfo,
                                            };
                                            _g.label = 1;
                                        case 1:
                                            _g.trys.push([1, 4, , 6]);
                                            if (taskId === null) {
                                                throw new ApiRequestFailureError(information);
                                            }
                                            return [4 /*yield*/, this.waitUntilSessionIoResponse(taskId)];
                                        case 2:
                                            response = _g.sent();
                                            if (isTimeoutResponse(response)) {
                                                throw new TimeoutResponseError(information);
                                            }
                                            _a = response.result, msg = _a.msg, code = _a.code;
                                            if (!SUCCESS_CODE_LIST.includes(code)) {
                                                throw new MyDataUpdateError(msg, code, information);
                                            }
                                            (_c = (_b = this.handleError) === null || _b === void 0 ? void 0 : _b.removeError) === null || _c === void 0 ? void 0 : _c.call(_b, reqId);
                                            successList.push(taskInfo);
                                            return [4 /*yield*/, (onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(taskInfo))];
                                        case 3:
                                            _g.sent();
                                            return [3 /*break*/, 6];
                                        case 4:
                                            e_1 = _g.sent();
                                            this.sessionIO.logging(LogKey.MydataUpdaterResponseError, { error: e_1, taskInfo: taskInfo, information: information });
                                            if (isMyUpdaterError(e_1) &&
                                                UPDATER_RETRY_CODE_LIST.includes(e_1.code) &&
                                                // PfmsAsset2는 retry 하지 않는다.
                                                taskRequest.type !== TaskType.PfmsAsset2 &&
                                                retryCount < retryLimit) {
                                                retryList.push(taskInfo);
                                                return [2 /*return*/];
                                            }
                                            updateErrorInfo = __assign(__assign({}, taskInfo), { code: isMyUpdaterError(e_1) ? e_1.code : FE_UPDATE_ERROR_CODE.UNHANDLED_ERROR, msg: isMyUpdaterError(e_1) ? e_1.message : '처리되지 않은 오류', pathname: requestPathname });
                                            (_d = this.logger) === null || _d === void 0 ? void 0 : _d.error(e_1);
                                            (_f = (_e = this.handleError) === null || _e === void 0 ? void 0 : _e.addError) === null || _f === void 0 ? void 0 : _f.call(_e, reqId, updateErrorInfo);
                                            failureList.push(taskInfo);
                                            return [4 /*yield*/, (onFailure === null || onFailure === void 0 ? void 0 : onFailure(taskInfo))];
                                        case 5:
                                            _g.sent();
                                            return [3 /*break*/, 6];
                                        case 6: return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _e.sent();
                        return [2 /*return*/, {
                                successList: successList,
                                failureList: failureList,
                                retryList: retryList,
                            }];
                }
            });
        });
    };
    MyDataUpdater.prototype.updateWithRetry = function (_a, _b) {
        return __awaiter(this, arguments, void 0, function (_c, _d, _e, requestPathname) {
            var taskResponseList, taskResultInfo, newSuccessList, newFailureList, retryTaskRequestList, result;
            var taskList = _c.taskList, onSuccess = _c.onSuccess, onFailure = _c.onFailure;
            var retryLimit = _d.retryLimit, retryCount = _d.retryCount;
            var _f = _e === void 0 ? {
                successList: [],
                failureList: [],
            } : _e, successList = _f.successList, failureList = _f.failureList;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        this.sessionIO.logging(LogKey.MydataUpdaterTaskList, taskList);
                        return [4 /*yield*/, this.fetchUpdateRequestApi(taskList)];
                    case 1:
                        taskResponseList = _g.sent();
                        this.sessionIO.logging(LogKey.MydataUpdaterTaskResponseList, taskResponseList);
                        return [4 /*yield*/, this.waitUntilAllSessionIoResponse(taskResponseList, {
                                taskList: taskList,
                                onSuccess: onSuccess,
                                onFailure: onFailure,
                            }, { retryLimit: retryLimit, retryCount: retryCount }, requestPathname)];
                    case 2:
                        taskResultInfo = _g.sent();
                        newSuccessList = successList.concat(taskResultInfo.successList);
                        newFailureList = failureList.concat(taskResultInfo.failureList);
                        if (!(taskResultInfo.retryList.length > 0)) return [3 /*break*/, 4];
                        retryTaskRequestList = taskResultInfo.retryList.reduce(function (result, _a) {
                            var taskRequest = _a.taskRequest;
                            var newRequest = __assign(__assign({}, taskRequest), { force: true });
                            // 이전 요청과 중복 생성을 막기 위해, 재시도 요청중에 같은 내용이 있다면 추가하지 않는다.
                            if (!result.some(function (item) { return JSON.stringify(newRequest) === JSON.stringify(item); })) {
                                result.push(newRequest);
                            }
                            return result;
                        }, []);
                        return [4 /*yield*/, this.updateWithRetry({ taskList: retryTaskRequestList, onSuccess: onSuccess, onFailure: onFailure }, { retryLimit: retryLimit, retryCount: retryCount + 1 }, { successList: newSuccessList, failureList: newFailureList }, requestPathname)];
                    case 3:
                        result = _g.sent();
                        return [2 /*return*/, result];
                    case 4: return [2 /*return*/, { successList: newSuccessList, failureList: newFailureList }];
                }
            });
        });
    };
    MyDataUpdater.prototype.update = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b, _c) {
            var requestPathname, result;
            var _d, _e;
            var taskList = _b.taskList, onSuccess = _b.onSuccess, onFailure = _b.onFailure;
            var _f = _c === void 0 ? { retryLimit: 2, retryCount: 0 } : _c, retryLimit = _f.retryLimit, retryCount = _f.retryCount;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0: return [4 /*yield*/, this.sessionIoInit()];
                    case 1:
                        _g.sent();
                        requestPathname = window.location.pathname;
                        return [4 /*yield*/, this.updateWithRetry({ taskList: taskList, onSuccess: onSuccess, onFailure: onFailure }, {
                                retryLimit: retryLimit,
                                retryCount: retryCount,
                            }, undefined, requestPathname)];
                    case 2:
                        result = _g.sent();
                        this.sessionIO.logging(LogKey.MydataUpdaterTaskResponseInfo, result);
                        (_e = (_d = this.logger) === null || _d === void 0 ? void 0 : _d.info) === null || _e === void 0 ? void 0 : _e.call(_d, result);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return MyDataUpdater;
}());

var TaskListBuilder = /** @class */ (function () {
    function TaskListBuilder() {
        this.taskList = [];
    }
    TaskListBuilder.prototype.addTaskList = function (type, list) {
        var _this = this;
        list.forEach(function (item) {
            _this.taskList.push(__assign({ type: type, reqId: JSON.stringify(item) }, item));
        });
    };
    TaskListBuilder.prototype.addAssetListTask = function (list) {
        this.addTaskList(TaskType.AssetList, list);
        return this;
    };
    TaskListBuilder.prototype.addAssetDetailTask = function (list) {
        this.addTaskList(TaskType.AssetDetail, list);
        return this;
    };
    TaskListBuilder.prototype.addAssetStatementListTask = function (list) {
        this.addTaskList(TaskType.AssetStatementList, list);
        return this;
    };
    TaskListBuilder.prototype.addCardBillListTask = function (list) {
        this.addTaskList(TaskType.CardBillList, list);
        return this;
    };
    TaskListBuilder.prototype.addCardPointTask = function (list) {
        this.addTaskList(TaskType.CardPoint, list);
        return this;
    };
    TaskListBuilder.prototype.addCardLoanTask = function (list) {
        this.addTaskList(TaskType.CardLoan, list);
        return this;
    };
    TaskListBuilder.prototype.addAccountScheduledTask = function (list) {
        this.addTaskList(TaskType.AccountScheduled, list);
        return this;
    };
    TaskListBuilder.prototype.addTelecomBillTask = function (list) {
        this.addTaskList(TaskType.TelecomBill, list);
        return this;
    };
    /**
     * @deprecated addPfms2Task 를 쓰세요.
     */
    TaskListBuilder.prototype.addPfmsTask = function (list) {
        this.addTaskList(TaskType.Pfms, list);
        return this;
    };
    TaskListBuilder.prototype.addPfms2Task = function (list) {
        this.addTaskList(TaskType.Pfms2, list);
        return this;
    };
    /**
     * @deprecated addPfmsAsset2Task 를 쓰세요.
     */
    TaskListBuilder.prototype.addPfmsAssetTask = function (list) {
        this.addTaskList(TaskType.PfmsAsset, list);
        return this;
    };
    TaskListBuilder.prototype.addPfmsAsset2Task = function (list) {
        this.addTaskList(TaskType.PfmsAsset2, list);
        return this;
    };
    TaskListBuilder.prototype.build = function () {
        return this.taskList;
    };
    return TaskListBuilder;
}());

/**
 * https://oss.fin.navercorp.com/techFin/myasset-plan/issues/1703
 * 갱신 요청 시에 apiType으로 헤더 설정 지원
 */
var UPDATE_API_TYPE;
(function (UPDATE_API_TYPE) {
    UPDATE_API_TYPE["USER_CONSENT"] = "user-consent";
    UPDATE_API_TYPE["USER_REFRESH"] = "user-refresh";
    UPDATE_API_TYPE["USER_SEARCH"] = "user-search";
    UPDATE_API_TYPE["SCHEDULED"] = "scheduled";
})(UPDATE_API_TYPE || (UPDATE_API_TYPE = {}));

var PFMSUpdater = /** @class */ (function () {
    function PFMSUpdater(sessionIO, _a) {
        var fetch = _a.fetch, logger = _a.logger;
        this.sessionIO = sessionIO;
        this.fetch = fetch;
        this.logger = logger;
    }
    PFMSUpdater.prototype.sessionIoInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sessionIO.init()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.sessionIO.waitUntilInitialized()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PFMSUpdater.prototype.waitUntilSessionIoResponse = function (taskId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            var _this = this;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, new Promise(function (resolve) {
                            _this.sessionIO.subscribe(taskId, resolve);
                        })];
                    case 1:
                        response = _c.sent();
                        (_b = (_a = this.logger) === null || _a === void 0 ? void 0 : _a.info) === null || _b === void 0 ? void 0 : _b.call(_a, response);
                        return [2 /*return*/, response];
                }
            });
        });
    };
    PFMSUpdater.prototype.waitUntilAllSessionIoResponse = function (taskResponseList_1, _a) {
        return __awaiter(this, arguments, void 0, function (taskResponseList, _b) {
            var _this = this;
            var onSuccess = _b.onSuccess, onFailure = _b.onFailure;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, Promise.all(taskResponseList.map(function (taskResponse) { return __awaiter(_this, void 0, void 0, function () {
                            var taskId, month, information, response, _a, msg, code, error_1;
                            var _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        taskId = taskResponse.taskId, month = taskResponse.month;
                                        information = {
                                            taskId: taskId,
                                        };
                                        _c.label = 1;
                                    case 1:
                                        _c.trys.push([1, 4, , 6]);
                                        if (taskId === null) {
                                            throw new ApiRequestFailureError(information);
                                        }
                                        return [4 /*yield*/, this.waitUntilSessionIoResponse(taskId)];
                                    case 2:
                                        response = _c.sent();
                                        if (isTimeoutResponse(response)) {
                                            throw new TimeoutResponseError(information);
                                        }
                                        _a = response.result, msg = _a.msg, code = _a.code;
                                        if (!SUCCESS_CODE_LIST.includes(code)) {
                                            throw new MyDataUpdateError(msg, code, information);
                                        }
                                        return [4 /*yield*/, (onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(month))];
                                    case 3:
                                        _c.sent();
                                        return [3 /*break*/, 6];
                                    case 4:
                                        error_1 = _c.sent();
                                        (_b = this.logger) === null || _b === void 0 ? void 0 : _b.error(error_1);
                                        return [4 /*yield*/, (onFailure === null || onFailure === void 0 ? void 0 : onFailure(month))];
                                    case 5:
                                        _c.sent();
                                        return [3 /*break*/, 6];
                                    case 6: return [2 /*return*/];
                                }
                            });
                        }); }))];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PFMSUpdater.prototype.update = function (_a, updatePFMSResponseHandler_1) {
        return __awaiter(this, arguments, void 0, function (_b, updatePFMSResponseHandler) {
            var taskResponse, error_2;
            var _c;
            var fromMonth = _b.fromMonth, toMonth = _b.toMonth, updateMyAsset = _b.updateMyAsset;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, this.sessionIoInit()];
                    case 1:
                        _d.sent();
                        return [4 /*yield*/, this.fetch.updateRequest({ fromMonth: fromMonth, toMonth: toMonth, udtMyasset: updateMyAsset })];
                    case 2:
                        taskResponse = _d.sent();
                        return [4 /*yield*/, this.waitUntilAllSessionIoResponse(taskResponse, updatePFMSResponseHandler)];
                    case 3:
                        _d.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_2 = _d.sent();
                        (_c = this.logger) === null || _c === void 0 ? void 0 : _c.error(error_2);
                        throw error_2;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return PFMSUpdater;
}());

export { ApiRequestFailureError, CONNECTION_ERROR_CODE_LIST, FE_UPDATE_ERROR_CODE, MyDataUpdateError, MyDataUpdater, PFMSUpdater, SUCCESS_CODE_LIST, SYSTEM_MAINTENANCE_ERROR_CODE_LIST, TEMPORARY_ERROR_CODE_LIST, TaskListBuilder, TimeoutResponseError, UPDATER_RETRY_CODE_LIST, UPDATE_API_TYPE, UP_TO_DATE_CODE_LIST, UnhandledError, isMyUpdaterError, isPfmsTaskRequest, isPfmsTaskResponse, isTimeoutResponse };
